export default __webpack_public_path__ + "assets/a809eb58547d75751436e75eee260033.jpg";